import { useCallback, useMemo } from "react";
import { useDemandStudioContext } from "../contexts/DemandStudioContext";

// derives display props and stable handlers from a section comment object
const useDemandStudioComment = ({ section, index }) => {
  const {
    hasSearch,
    updateSectionComment,
    handleRegenerateSection,
    handleEditSection,
    handleCardFocus,
    getSectionUiState,
    focusedSectionId,
  } = useDemandStudioContext();

  const sectionNumber = index + 1;
  const isAlternate = index % 2 === 1;
  const label = section.label;
  const name = `demandStudioComment-${section.id}`;
  const value = section.comment;
  const uiState = getSectionUiState(section.id);
  const isFocused = !hasSearch && focusedSectionId === section.id;

  const onChange = useCallback(
    (nextValue) => updateSectionComment(section.id, nextValue),
    [section.id, updateSectionComment]
  );

  const onRegenerate = useCallback(
    () => handleRegenerateSection(section.id),
    [section.id, handleRegenerateSection]
  );

  const onEditSection = useCallback(
    () => handleEditSection(section.id),
    [section.id, handleEditSection]
  );

  const onCardFocus = useCallback(
    () => handleCardFocus(section.id),
    [section.id, handleCardFocus]
  );

  return useMemo(() => ({
    sectionNumber,
    isAlternate,
    label,
    name,
    value,
    uiState,
    isFocused,
    onChange,
    onRegenerate,
    onEditSection,
    onCardFocus,
  }), [
    sectionNumber, isAlternate, label, name, value,
    uiState, isFocused, onChange, onRegenerate, onEditSection, onCardFocus,
  ]);
};

export default useDemandStudioComment;
